import React, { useState, useRef, useEffect, useContext } from 'react';
import { getFirestore, runTransaction, addDoc, updateDoc, arrayRemove, arrayUnion, writeBatch, deleteDoc, deleteField, increment, setDoc, serverTimestamp, doc, getDoc, collection, query, where, getDocs, orderBy, startAfter, limit, onSnapshot } from 'firebase/firestore';
import { AppContext } from './AppContext';
import { firestore } from './firebase';
import { getAuth } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import ProfilesDisplaySharePost from './ProfilesDisplaySharePost';
import LikeIcon from './assets/LikeIcon.png'; // Import the image
import LikeIconActive from './assets/LikeIconActive.png'; // Import the active image
import CommentIcon from './assets/CommentIcon.png'; // Import other icons similarly
import RepostIcon from './assets/RepostIcon.png';
import RepostIconActive from './assets/RepostIconActive.png';
import ellipsis from './assets/ellipsis-v.png';
import PlayButton from './assets/PlayButton.png';
import ArtistIcon1 from './assets/ArtistIcon1.png';
import ArtistIcon2 from './assets/ArtistIcon2.png';
import Modal from 'react-modal';
import { ProfilesDisplayShareDATpost } from './ProfilesDisplayShareDATpost';
import { SharePostPopup } from './SharePostPopup';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FaEye, FaPaperPlane } from 'react-icons/fa';
import { IoVolumeHigh, IoVolumeMuteOutline, IoMusicalNotesOutline } from 'react-icons/io5';
import { getDatabase, ref as rtdbRef, get as rtdbGet } from 'firebase/database';

const CACHE_DURATION = 12;
const bottomAreaHeight = window.innerHeight * 0.3;
const scrollAreaTopPadding = window.innerHeight * 0.17;

const Social = ({ onProfilePress, onMoveMP }) => {
  const [refreshing, setRefreshing] = useState(false);
  const [viewMode, setViewMode] = useState('horizontal');
  const { showSharePostPopup, setShowSharePostPopup, showMediaPopup, currentUser, setCurrentlyLoadingProfile, setViewingProfile, setActivePopupMedia,
    activePopupMedia, setTrackToView, setIsExpandedShare, setIsLoadingHideEA, setInitiallySelectedItemId, setActiveTab, setIsExpanded, setIsLoadingArtwork,
    setIsLoadingProfilePicture, setIsLoadingExpand, setIsLoadingNewPopup, setArtworkUri, setInitialExpandedAlbumAndSong, setCenteredRelease, setHideExpandedAlbum, 
    userId2, likes, setLikes, posts, setPosts, reposts, setReposts, sharePostActive, setSharePostActive, postToShare, setPostToShare, following,
    allPosts, setAllPosts, setMyPosts, assetsSummary, allSingles, allAlbums, setUserPosts,
    startViewingLivestream,
    joiningLive, setJoiningLive, tokensUtility, activeMedia,
    viewedVideos,
  addViewedVideo, videoCountCacheRef,
  } = useContext(AppContext);
  const [profiles, setProfiles] = useState([]);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);

const videoRefs = useRef({});

  const [liveUsers, setLiveUsers] = useState([]);



  const navigate = useNavigate();

  const [likedPosts, setLikedPosts] = useState({});
  const [lastVisiblePost, setLastVisiblePost] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const [allPostsLoaded, setAllPostsLoaded] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentVideoUri, setCurrentVideoUri] = useState(null);
  const [isSelecting, setIsSelecting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeItemId, setActiveItemId] = useState(null);
  const [reportComplete, setReportComplete] = useState(false);
  const [sharePost, setSharePost] = useState(false);
  const [currentPost, setCurrentPost] = useState(null);

  const viewabilityConfig = {
    itemVisiblePercentThreshold: 50  // Item needs to be 50% visible to trigger playback
  };

  const onViewableItemsChanged = useRef(({ viewableItems }) => {
    viewableItems.forEach(item => {
      const ref = videoRefs.current[item.item.imageUri];
      if (ref) {
        ref.playAsync();
      }
    });
    Object.keys(videoRefs.current).forEach(key => {
      if (!viewableItems.find(item => item.item.imageUri === key)) {
        if (videoRefs.current[key]) {
          videoRefs.current[key].pauseAsync();
        }
      }
    });
  }).current;

  const sortReleasesByTimestamp = (releases) => {
    const sortedReleases = [...releases].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);
  
    return sortedReleases;
  };

  const preparePopupData = (userData, userId) => {
    
     
     
    const albums = sortReleasesByTimestamp(userData.albums || []);
    const singles = sortReleasesByTimestamp(userData.singles || []);
    const videos = sortReleasesByTimestamp(userData.videos || []);
  
    let profileImageUrl = null;
  
  
  
    const popupData = {
      artistName: userData.artistName || userData.ArtistName,
      popupProfileImage: userData?.profileImageUrl,
      username: userData.username,
      accountType: userData.accountType,
      userId: userId,
      otherReleases: { albums, singles, videos },
      vocalDrop: userData.vocalDrop,
      voiceDropMuted: userData?.voiceDropMuted,
      bio: userData.bio,
      blurb: userData.blurb,
      location: userData.location,
      timestamp: new Date().getTime(),
      ScreenSKN: userData.ScreenSKN,
    };
  
    
    return popupData;
  };

  const handleProfileSelect = async (profileData, userId) => {

    try {
      
      setIsSelecting(true);
      const popupData = preparePopupData(profileData, userId);
      setActivePopupMedia(popupData); // This triggers the useEffect
      
    } catch (error) {
      console.error('handleProfileSelect: Error in handling profile selection:', error);
      setCurrentlyLoadingProfile(false);
    }
  };

  const handleRepost = async (post, newUserText = '', newUserImageUri = '') => {
  
    const db         = getFirestore();
    const currentUid = userId2;                       // our uid from context
    if (!currentUid || !post || !currentUser) return;
  
    let isUnrepost          = false;
    let deletedRepostId     = null;
    let newRepostData       = null;
    let updatedRepostCount  = 0;
  
    /* which post are we (un)reposting? */
    const targetPostId = post.originalPost ? post.originalPost.postId : post.postId;
    const originalRef  = doc(db, 'posts', targetPostId);
    const summaryRef   = doc(db, 'socialSummaryReposts', currentUid);
  
    /* ---------- helpers for optimistic UI ---------- */
    const bumpCount = (setter, delta) =>
      setter(arr => arr.map(p =>
        p.postId === targetPostId
          ? { ...p, repostCount: Math.max((p.repostCount || 0) + delta, 0) }
          : p
      ));
  
    const addRepost  = (setter, item) => setter(arr => [item, ...arr]);
    const dropRepost = (setter, rid)  => setter(arr => arr.filter(p => p.postId !== rid));
  
    try {
      await runTransaction(db, async (tx) => {
        /* 1️⃣  read data we need (original may no longer exist) */
        const [origSnap, sumSnap] = await Promise.all([
          tx.get(originalRef),
          tx.get(summaryRef)
        ]);
  
        const originalExists = origSnap.exists();
        const originalData   = originalExists ? origSnap.data() : null;
        const summaryData    = sumSnap.exists() ? sumSnap.data() : { reposts: {} };
  
        const existingId     = summaryData.reposts[targetPostId];
        const alreadyShared  = !!existingId;
  
        /* ===================================================
           UN-REPOST
           =================================================== */
        if (alreadyShared) {
          const repostId = existingId || post.postId;   // fallback if map is stale
  
          /* firestore */
          tx.delete(doc(db, 'posts', repostId));
          tx.update(summaryRef, {
            [`reposts.${targetPostId}`]: deleteField()
          });
  
          /* update counter only if original still exists */
          let newCount = 0;
          if (originalExists) {
            newCount = Math.max((originalData.repostCount || 1) - 1, 0);
            tx.update(originalRef, {
              repostCount:    newCount,
              repostUserIds:  arrayRemove(currentUid)
            });
          }
  
          /* optimistic UI */
          bumpCount(setPosts,      -1);
          bumpCount(setMyPosts,    -1);
          bumpCount(setAllPosts, -1);
          dropRepost(setPosts,     repostId);
          dropRepost(setMyPosts,   repostId);
          dropRepost(setAllPosts, repostId);

          const fixOriginal = p =>
            p.postId === targetPostId
              ? {
                  ...p,
                  repostCount   : Math.max((p.repostCount || 1) - 1, 0),
                  repostUserIds : (p.repostUserIds || []).filter(uid => uid !== currentUid)
                }
              : p;
          
          setPosts   (arr => arr.map(fixOriginal));
          setMyPosts (arr => arr.map(fixOriginal));
          setAllPosts(arr => arr.map(fixOriginal));
          
          unsyncedMineRef.current =
            unsyncedMineRef.current.map(fixOriginal);
          

          unsyncedMineRef.current =
    unsyncedMineRef.current.filter(p => p.postId !== repostId);
  
          setReposts(prev => {
            const out = { ...prev };
            delete out[targetPostId];
            return out;
          });
  
          /* expose flags for summary-doc maintenance */
          isUnrepost          = true;
          deletedRepostId     = repostId;
          updatedRepostCount  = newCount;
          return;   // transaction work finished
        }
  
        /* ===================================================
           CREATE REPOST  (only if original still exists)
           =================================================== */
        if (!originalExists) throw new Error('Original post missing – cannot repost');
  
        const repostRef  = doc(collection(db, 'posts'));
  
        /* local object for instant rendering */
        const localRepost = {
          postId        : repostRef.id,
          text          : newUserText,
          imageUri      : newUserImageUri,           // may be '' but never undefined
          userId        : currentUid,
          accountType   : currentUser.accountType,
          username      : currentUser.username,
          name          : currentUser.name,
          profileImageUrl : currentUser.profileImageUrl,
          createdAt     : Date.now(),
          originalPost  : {
            postId       : originalData.postId,
            id           : targetPostId,
            userId       : originalData.userId,
            imageWidth   : originalData.imageWidth ?? '1',
            imageHeight  : originalData.imageHeight ?? '1',
            username     : originalData.username,
            name         : originalData.name,
            tags         : originalData.tags ?? [],
            mediaType    : originalData.mediaType ?? '',
            profileImageUrl: originalData.profileImageUrl,
            text         : originalData.text,
            ...(originalData.imageUri    && { imageUri   : originalData.imageUri }),
            ...(originalData.accountType && { accountType: originalData.accountType }),
            ...(originalData.userRef     && { userRef    : originalData.userRef }),
            ...(originalData.profile     && { profile    : originalData.profile }),
            ...(originalData.media       && { media      : originalData.media }),
          },
          likeCount      : 0,
          repostCount    : 0,
          likes          : {},
          comments       : [],
          repostUserIds  : [],
        };
  
        /* firestore copy */
        tx.set(repostRef, { ...localRepost, createdAt: serverTimestamp() });
  
        /* update summary map */
        summaryData.reposts[targetPostId] = repostRef.id;
        tx.set(summaryRef, summaryData, { merge: true });
  
        /* bump original counter */
        const newCount = (originalData.repostCount || 0) + 1;
        tx.update(originalRef, {
          repostCount:    newCount,
          repostUserIds:  arrayUnion(currentUid),
        });
  
        /* optimistic UI */
        bumpCount(setPosts,      +1);
        bumpCount(setMyPosts,    +1);
        addRepost(setPosts,      localRepost);
        addRepost(setMyPosts,    localRepost);
  
        setReposts(prev => ({ ...prev, [targetPostId]: true }));
  
        /* expose for summary-doc section */
        newRepostData       = localRepost;
        updatedRepostCount  = newCount;
      });
  
      /* ========== summary-doc maintenance (outside tx) ========== */
      const summariesRef = collection(db, 'socialSummaries');
      const newestSnap   = await getDocs(
        query(summariesRef, orderBy('__name__', 'desc'), limit(1))
      );
  
      let summaryDocRef, summaryData;
      if (!newestSnap.empty) {
        summaryDocRef = newestSnap.docs[0].ref;
        summaryData   = newestSnap.docs[0].data();
      } else {
        summaryDocRef = doc(summariesRef, 'summary_1');
        summaryData   = { posts: [], sizeEstimate: 0 };
      }
  
      let postsArr = summaryData.posts || [];
      let changed  = false;
  
      /* sync counter on original IF original still exists */
      postsArr = postsArr.map(p => {
        if (p.postId !== targetPostId) return p;
      
        const withoutMe = (p.repostUserIds || []).filter(uid => uid !== currentUid);
      
        return {
          ...p,
          repostCount   : updatedRepostCount,   // 0 after an unre-post
          repostUserIds : withoutMe
        };
      });
      
  
      if (isUnrepost) {
        const before = postsArr.length;
        postsArr = postsArr.filter(p => p.postId !== deletedRepostId);
        changed |= before !== postsArr.length;
      } else if (newRepostData) {
        const exists = postsArr.some(p => p.postId === newRepostData.postId);
        if (!exists) {
          const est       = 200 + new TextEncoder().encode(JSON.stringify(newRepostData)).length;
          const threshold = 950000;
          if ((summaryData.sizeEstimate || 0) + est > threshold) {
            /* document full – create a new one */
            const parts     = summaryDocRef.id.split('_');
            const nextIndex = parts.length === 2 ? parseInt(parts[1], 10) + 1 : 1;
            await setDoc(doc(summariesRef, `summary_${nextIndex}`), {
              posts: [{ ...newRepostData, createdAt: Date.now(), repostCount: updatedRepostCount }],
              sizeEstimate: est,
            });
          } else {
            postsArr.push({
              ...newRepostData,
              createdAt: Date.now(),
              repostCount: updatedRepostCount
            });
            summaryData.sizeEstimate = (summaryData.sizeEstimate || 0) + est;
            changed = true;
          }
        }
      }
  
      if (changed) {
        await updateDoc(summaryDocRef, {
          posts:        postsArr,
          sizeEstimate: summaryData.sizeEstimate || 0
        });
      }
    } catch (err) {
      console.error('❌ handleRepost failed:', err);
    }
  };



  const handleRepostDeletion = (postId) => {
    const repostId = reposts[postId];
    if (repostId) {
      setReposts(reposts => {
        const updatedReposts = { ...reposts };
        delete updatedReposts[postId];
        return updatedReposts;
      });
    }
  };

  const fetchLikes = async (posts) => {
    const db = getFirestore();
    const userId = getAuth().currentUser.uid;
    const likedPostsQuery = query(collection(db, 'likes'), where('userId', '==', userId));
    const querySnapshot = await getDocs(likedPostsQuery);
    const likes = {};
    querySnapshot.forEach((doc) => {
      likes[doc.data().postId] = true;
    });
    setLikedPosts(likes);
  };

    useEffect(() => {
    const db = getFirestore();
    const liveListRef = doc(db, 'LiveSocial', 'LiveList');

    const unsubscribe = onSnapshot(liveListRef, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setLiveUsers(Array.isArray(data.liveUsers) ? data.liveUsers : []);
      } else {
        setLiveUsers([]);
      }
    }, (err) => {
      console.error('Live list snapshot error:', err);
    });

    return () => unsubscribe();
  }, []);


  useEffect(() => {
    if (isSelecting && activePopupMedia) {
      onProfilePress();
      setCurrentlyLoadingProfile(false);
      setIsSelecting(false);
    }
  }, [activePopupMedia]);

  const postsLimit = 7;

  const lastVisiblePostRef = useRef(null);
  const [showActivityIndicator, setShowActivityIndicator] = useState(false);

  const lastSummaryDocRef = useRef(null);

  const unsyncedMineRef = useRef([]);

  const loadedSummaryIdsRef = useRef(new Set());
  const postsBatchSize = 20;

  const isRenderableNFT = (p) => {
    const postOk  = !p.media               || p.media.isNFT === true;
    const origOk  = !p.originalPost?.media || p.originalPost.media.isNFT === true;
    return postOk && origOk;
  };


  const VIEWCOUNT_TTL_MS = 60 * 1000;

  const fetchVideoCountsForList = async (items, { forceRefresh = false } = {}) => {
  const db = getDatabase();
  const now = Date.now();
  const tasks = [];

  for (const item of items) {
    if (!item || item.mediaType !== 'video' || !item.postId) continue;
    const id = item.postId;

    const cached = videoCountCacheRef.current.get(id);
    const isFresh = cached && (now - cached.ts) < VIEWCOUNT_TTL_MS;
    if (!forceRefresh && isFresh) continue;

    tasks.push(
      rtdbGet(rtdbRef(db, `counters/${id}`))
        .then(snap => {
          const val = typeof snap.val() === 'number' ? snap.val() : (item.viewCount ?? 0);
          videoCountCacheRef.current.set(id, { val, ts: Date.now() });
          return { id, val };
        })
        .catch(() => null)
    );
  }

  const results = (await Promise.all(tasks)).filter(Boolean);
  if (!results.length) return;

  setPosts(prev =>
    prev.map(p =>
      p?.mediaType === 'video' && videoCountCacheRef.current.has(p.postId)
        ? { ...p, viewCount: videoCountCacheRef.current.get(p.postId).val }
        : p
    )
  );
};

const fetchPosts = async (loadMore = false) => {
  const bypassFilterIds = [
    "h0fEIStkM4XHTDErZM5i8XIo9rA3",
    "OHaY20b54nTGd5BBgbJOL2BHEbX2",
    "rdX289s3YBP31Hw5qn2eXVywtBq1",
    "Mkf4631LCEOYmHXWRzGirPdxBrt1"
  ];
  const shouldBypassFilter = true;

  if (!shouldBypassFilter && !following?.length) {
    console.log('No users to follow.');
    setPosts([]);
    setAllPostsLoaded(true);
    return;
  }

  // If a loadMore comes in before we've seeded the feed, do the initial load first.
  if (loadMore && allPosts.length === 0) {
    console.log('[loadMore] no seed yet -> doing initial load');
    await fetchPosts(false);
    return;
  }

  if (loadMore && allPostsLoaded) {
    console.log('No more posts to load.');
    return;
  }

  if (isLoading) {
    console.log('Fetch already in progress.');
    return;
  }

  setIsLoading(true);
  if (!loadMore && allPosts.length === 0) {
    setShowActivityIndicator(true);
  }

  const db = getFirestore();

  if (!loadMore) {
    // ───── initial load (fetch latest TWO summary docs) ─────
    const summaryQuery = query(
      collection(db, 'socialSummaries'),
      orderBy('__name__', 'desc'),
      limit(2)
    );
    const summarySnapshot = await getDocs(summaryQuery);
    if (summarySnapshot.empty) {
      console.log('No summary docs found.');
      setPosts([]);
      setAllPostsLoaded(true);
      setIsLoading(false);
      setShowActivityIndicator(false);
      return;
    }

    const docs = summarySnapshot.docs;
    const latestDoc = docs[0];
    const secondDoc = docs.length > 1 ? docs[1] : null;

    // Set the cursor to the OLDER of the two (so next loadMore pulls the next older one).
    lastSummaryDocRef.current = secondDoc ? secondDoc.id : latestDoc.id;
    loadedSummaryIdsRef.current.add(latestDoc.id);
    if (secondDoc) loadedSummaryIdsRef.current.add(secondDoc.id);

    // Combine posts from the two newest summaries
    let fetchedPosts = [];
    for (const d of docs) {
      const data = d.data();
      if (Array.isArray(data?.posts) && data.posts.length) {
        fetchedPosts.push(...data.posts);
      }
    }

    if (!shouldBypassFilter) {
      fetchedPosts = fetchedPosts.filter(
        post =>
          post.userId === userId2 ||
          following.includes(post.userId)
      );
    }

    fetchedPosts = fetchedPosts.sort((a, b) => b.createdAt - a.createdAt);

    // ───── merge any locally newer posts ─────
    const newestFetchedAt = fetchedPosts.length ? fetchedPosts[0].createdAt : 0;

    const localExisting = allPosts.filter(
      p => p.userId === userId2 && p.createdAt > newestFetchedAt
    );

    const localNewer = unsyncedMineRef.current || [];

    const map = new Map();
    [...localExisting, ...localNewer, ...fetchedPosts].forEach(p => {
      if (p?.postId) map.set(p.postId, p);
    });

    const mergedAll = Array.from(map.values()).sort((a, b) => b.createdAt - a.createdAt);

    setAllPosts(mergedAll);
    setPosts(mergedAll.slice(0, postsBatchSize));

    // ↓↓↓ hydrate initial slice with RTDB counts (forceRefresh)
    const initialSlice = mergedAll.slice(0, postsBatchSize);
    fetchVideoCountsForList(initialSlice, { forceRefresh: true });

    if (mergedAll.length <= postsBatchSize) setAllPostsLoaded(true);

  } else {
    // ───── load-more branch ─────
    if (posts.length < allPosts.length) {
      const nextBatch = allPosts.slice(posts.length, posts.length + postsBatchSize);
      setPosts(prev => [...prev, ...nextBatch]);

      // ↓↓↓ hydrate the appended batch with RTDB counts (no force)
      fetchVideoCountsForList(nextBatch, { forceRefresh: false });

      setShowActivityIndicator(false);
    } else {
      let currentId = lastSummaryDocRef.current;

      // Fallback: if the cursor isn't ready (e.g., a race), recompute from latest doc.
      if (!currentId) {
        console.log('[loadMore] cursor missing; recomputing from latest doc');
        const latestSnap = await getDocs(
          query(collection(db, 'socialSummaries'), orderBy('__name__', 'desc'), limit(1))
        );
        if (!latestSnap.empty) {
          currentId = latestSnap.docs[0].id;
          lastSummaryDocRef.current = currentId;
          loadedSummaryIdsRef.current.add(currentId);
        } else {
          console.log('No summary docs available.');
          setAllPostsLoaded(true);
          setIsLoading(false);
          setShowActivityIndicator(false);
          return;
        }
      }

      const currentIndex = parseInt(String(currentId).split('_')[1], 10);
      const nextIndex = currentIndex - 1;

      if (!Number.isFinite(currentIndex) || nextIndex < 1) {
        console.log('No older summary docs.');
        setAllPostsLoaded(true);
        setIsLoading(false);
        setShowActivityIndicator(false);
        return;
      }

      const summaryDocId = `summary_${nextIndex}`;
      if (loadedSummaryIdsRef.current.has(summaryDocId)) {
        console.log('Summary already loaded:', summaryDocId);
        setAllPostsLoaded(true);
        setIsLoading(false);
        setShowActivityIndicator(false);
        return;
      }

      lastSummaryDocRef.current = summaryDocId;
      loadedSummaryIdsRef.current.add(summaryDocId);

      const summaryDocRef = doc(db, 'socialSummaries', summaryDocId);
      const summaryDocSnap = await getDoc(summaryDocRef);
      if (!summaryDocSnap.exists()) {
        console.log('Summary doc does not exist:', summaryDocId);
        setAllPostsLoaded(true);
        setIsLoading(false);
        setShowActivityIndicator(false);
        return;
      }

      let fetchedPosts = Array.isArray(summaryDocSnap.data()?.posts)
        ? summaryDocSnap.data().posts
        : [];

      if (!shouldBypassFilter) {
        fetchedPosts = fetchedPosts.filter(post =>
          following.includes(post.userId)
        );
      }

      fetchedPosts = fetchedPosts.sort((a, b) => b.createdAt - a.createdAt);

      // De-dupe against existing allPosts by postId
      setAllPosts(prevAll => {
        const existing = new Set(prevAll.map(p => p.postId));
        const toAppend = fetchedPosts.filter(p => p?.postId && !existing.has(p.postId));
        return [...prevAll, ...toAppend];
      });

      setPosts(prevPosts => {
        const prevIds = new Set(prevPosts.map(p => p.postId));
        const toAppend = fetchedPosts.filter(p => p?.postId && !prevIds.has(p.postId));
        const slice = toAppend.slice(0, postsBatchSize);
        return [...prevPosts, ...slice];
      });

      // ↓↓↓ hydrate the new slice (from older summary) with RTDB counts (no force)
      const appendBatch = fetchedPosts.slice(0, postsBatchSize);
      fetchVideoCountsForList(appendBatch, { forceRefresh: false });

      if (fetchedPosts.length < postsBatchSize) {
        setAllPostsLoaded(true);
      }
    }
  }

  setIsLoading(false);
  setShowActivityIndicator(false);
};

  

  useEffect(() => {
    if (following?.length > 0 && !isLoadingPosts) {
      fetchPosts();
    }
  }, [following]);

  const onRefresh = React.useCallback(() => {
    setRefreshing(true);
    fetchPosts().then(() => setRefreshing(false));
  }, [following]);

  const handleLikePress = async (postId) => {
    const currentUserId = userId2;                 // already in context
    if (!currentUserId) {
      console.warn('No signed-in user');
      return;
    }
  
    const db               = getFirestore();
    const postRef          = doc(db, 'posts', postId);
    const likeDocRef       = doc(collection(db, 'likes'), `${currentUserId}_${postId}`);
    const userLikesRef     = doc(db, `users/${currentUserId}/likes`, postId); // optional legacy sub-collection
    const summaryLikesRef  = doc(db, 'socialSummaryLikes', currentUserId);    // your summary doc
  
    /* ---------- optimistic UI ---------- */
    const alreadyLiked = !!likes?.[postId];
  
    // 1) summary map in context
    setLikes(prev => {
      const out = { ...(prev || {}) };
      if (alreadyLiked) { delete out[postId]; }
      else               { out[postId] = true; }
      return out;
    });
  
    // 2) helper to bump likeCount + local likes map inside any post array
    const bumpArr = (setter) => setter(arr => {
      const copy = [...arr];
      const idx  = copy.findIndex(p => p.postId === postId);
      if (idx === -1) return arr;
  
      const p        = { ...copy[idx] };
      const likesMap = { ...(p.likes || {}) };
  
      if (alreadyLiked) {
        delete likesMap[currentUserId];
        p.likeCount = Math.max((p.likeCount || 1) - 1, 0);
      } else {
        likesMap[currentUserId] = true;
        p.likeCount = (p.likeCount || 0) + 1;
      }
  
      p.likes = likesMap;
      copy[idx] = p;
      return copy;
    });
  
    bumpArr(setMyPosts);
    bumpArr(setUserPosts);
    bumpArr(setPosts);
  
    /* ---------- Firestore transaction ---------- */
    try {
      await runTransaction(db, async (tx) => {
        // 1. post doc
        const postSnap = await tx.get(postRef);
        if (!postSnap.exists()) throw new Error('Post missing');
        const postData = postSnap.data();
        const likesMap = { ...(postData.likes || {}) };
        let likeCount  = postData.likeCount || 0;
  
        // 2. likes summary doc
        const summarySnap = await tx.get(summaryLikesRef);
        const summaryData = summarySnap.exists() ? summarySnap.data() : { likes: {} };
  
        if (alreadyLiked) {
          /* UN-LIKE */
          tx.delete(likeDocRef);
          tx.delete(userLikesRef);
          delete likesMap[currentUserId];
          delete summaryData.likes[postId];
          likeCount = Math.max(likeCount - 1, 0);
        } else {
          /* LIKE */
          tx.set(likeDocRef, {
            postId,
            userId: currentUserId,
            creatorId: postData.userId,
            name: currentUser?.name || '',
            profileImageUrl: currentUser?.profileImageUrl || '',
            createdAt: serverTimestamp()
          });
          tx.set(userLikesRef, { createdAt: serverTimestamp() });
          likesMap[currentUserId]    = true;
          summaryData.likes[postId]  = true;
          likeCount += 1;
        }
  
        tx.update(postRef,     { likeCount, likes: likesMap });
        tx.set(   summaryLikesRef, summaryData, { merge: true });
  
        // --- Update the post object within each summary document ---
        const summariesRef      = collection(db, "socialSummaries");
        const summariesSnapshot = await getDocs(summariesRef);
        for (const summaryDoc of summariesSnapshot.docs) {
          const data = summaryDoc.data();
          if (Array.isArray(data.posts)) {
            const postsArray = data.posts;
            const idx = postsArray.findIndex(p => p.postId === postId);
            if (idx !== -1) {
              postsArray[idx].likeCount = likeCount;
              postsArray[idx].likes     = likesMap;
              tx.update(summaryDoc.ref, { posts: postsArray });
              break; // assume each post appears in only one summary
            }
          }
        }
      });
      
    } catch (error) {
      console.error("Transaction failed: ", error);
    }
  };

  const handlePressPost = (post) => {
    // Clone the post object to ensure it only contains cloneable data
    const clonedPost = JSON.parse(JSON.stringify(post));
    navigate('/viewpost', {
      state: {
        post: clonedPost,
        isLiked: !!likes[post.id],
        isReposted: !!reposts[post.id]
      }
    });
  };

  const handlePressPostComment = (post) => {
    // Clone the post object to ensure it only contains cloneable data
    const clonedPost = JSON.parse(JSON.stringify(post));
    navigate('/viewpost', {
      state: {
        post: clonedPost,
        isLiked: !!likes[post.id],
        isReposted: !!reposts[post.id],
        focusCommentInput: true
      }
    });
  };
  
  const handlePressOriginalPost = (originalPost) => {
    // Clone the originalPost object to ensure it only contains cloneable data
    const clonedOriginalPost = JSON.parse(JSON.stringify(originalPost));
    navigate('/viewpost', {
      state: {
        post: clonedOriginalPost,
        isLiked: !!likes[originalPost.id],
        isReposted: !!reposts[originalPost.id],
        isOriginalFromRepost: true
      }
    });
  };


  const getCachedUserDocSHARE = async (userId) => {
    let userDataCached = [];
    let userDataCachedNew = [];
      
      const userDocRef = doc(firestore, 'users', userId);
      const userDocSnap = await getDoc(userDocRef);
  
      if (userDocSnap.exists()) {
        
        const freshUserData = userDocSnap.data();
  
        
  
  
  
        // Update userDataCached structure with fresh data and timestamp, keep old local URLs initially.
        userDataCachedNew = {
          ...freshUserData, // overwrite with fresh data from Firestore
          profileImageUrl: freshUserData.profileImageUrl,
        };
  
  
  
        // Persist any updates in the cache and database
  
      } else {
        console.error(`[getCachedUserDoc] No document found in Firestore for userId: ${userId}`);
      }
    
  
    return userDataCachedNew;
  };

  const handleNavigateMovie = async (movie) => {
    navigate('/movieview', { state: { movie: movie } } );
  };



  const handleMove = (song) => {
    if (song?.isNFT) {
      const matchedSong = assetsSummary.find(
        item => item.contentId === song.contentId
      ) || song;
    
      // deep clone the matched item
      const clonedSong = JSON.parse(JSON.stringify(matchedSong));
      navigate(`/dat/${song.id}`, { state: { nft: clonedSong } });
    } else {
      const matchedSong =
      allSingles.find(item => item.contentId === song.contentId) ||
      allAlbums.find(item => item.contentId === song.contentId) ||
      song;
    
    
      // deep clone the matched item
      const clonedSong = JSON.parse(JSON.stringify(matchedSong));
    navigate('/view-song', { state: { song: clonedSong } });
    }
  };

  const handlePressBeginsSHARE = async (song) => {
    const fetchedUserData = await getCachedUserDocSHARE(song.artistUserId);
    const profileData = fetchedUserData;
    const updatedProfileData = await updateSongWithProfileData(profileData, song);
    
    if (updatedProfileData) {
      const clonedSong = JSON.parse(JSON.stringify(updatedProfileData));
      navigate('/view-song', { state: { song: clonedSong } });
    }
  };
  
  const updateSongWithProfileData = async (profileData, song) => {
    const { singles = [], albums = [], videos = [], spncasts = [] } = profileData;
    const allReleases = [...singles, ...albums, ...videos, ...spncasts];
    const matchedSong = allReleases.find(release => release.contentId === song.contentId);
    
    if (matchedSong) {
      song.ArtistName = matchedSong.ArtistName || song.ArtistName;
      song.SongName = matchedSong.SongName || song.SongName;
      song.albumName = matchedSong.albumName || song.albumName;
      song.producers = matchedSong.producers || song.producers;
      song.songwriters = matchedSong.songwriters || song.songwriters;
      song.recordLabels = matchedSong.recordLabels || song.recordLabels;
      song.VideoURL = matchedSong.VideoURL || song.VideoURL;
      song.ArtworkURL = matchedSong.ArtworkURL || song.ArtworkURL;
      return matchedSong;
    }
    return song;
  };

  const [comments, setComments] = useState([]);

  const [localCommentCount, setLocalCommentCount] = useState([]);

  const getPid = p => p?.postId || p?.id || '';

const DELETE_WAIT_MS = 25_000;

  const handleDelete = async () => {
    if (!activeItemId) return;
  
    const { post, type, commentId, postId } = activeItemId;
    if (post?.originalPost) {            // if we tapped a repost, delegate
      handleRepost(post);
      return;
    }
  
    const db   = getFirestore();
    let  ref   = null;                   // reference to the thing we’re deleting
  
    if (type === 'post')      ref = doc(db, 'posts', post.postId);
    else if (type === 'comment')
      ref = doc(db, 'posts', postId, 'comments', post.postId);
    else if (type === 'reply')
      ref = doc(db, 'posts', postId, 'comments', commentId, 'replies', post.postId);
  
    if (!ref) { console.error('Failed to build Firestore reference for deletion.'); return; }
  
    try {
      /* ─────────────── delete the item itself ─────────────── */
      await deleteDoc(ref);
      console.log(`${type} deleted:`, post.postId);
  
      /* ----------------------------------------------------------------
         EXTRA WORK  (only when we’ve deleted an ORIGINAL POST)
         – find and purge every repost that pointed at it
         – clean up mapping docs + summary docs
         ---------------------------------------------------------------- */
         if (type === 'post') {


          const createdAtMs =
          typeof post.createdAt === "number"
            ? post.createdAt
            : post.createdAt?.toMillis?.() ?? 0;
    
        const age = Date.now() - createdAtMs;
    



          const repostIds = [];                           // collect child-reposts
          const db        = getFirestore();
        
          /* 1️⃣ grab every repost that points at this post */
          const repostsSnap = await getDocs(
            query(collection(db, 'posts'),
                  where('originalPost.postId', '==', post.postId))
          );
        
          /* 2️⃣ batch-delete those repost docs + tidy their summary-repost maps */
          if (!repostsSnap.empty) {
            const batch = writeBatch(db);
            repostsSnap.forEach(d => {
              const rid   = d.id;
              const uid   = d.data().userId;
              repostIds.push(rid);
        
              batch.delete(d.ref);   // delete the repost itself
              batch.update(          // remove entry in socialSummaryReposts/<uid>
                doc(db, 'socialSummaryReposts', uid),
                { [`reposts.${post.postId}`]: deleteField() }
              );
            });
            await batch.commit();
            console.log(`[delete] also removed ${repostIds.length} repost(s)`);
          }
        
/* 3️⃣ prune every local buffer ---------------------------------------- */
const idsGone  = new Set([post.postId, ...repostIds]);

const keep = arr =>
  arr.filter(p =>
    !idsGone.has(getPid(p)) &&                      // the post itself
    !idsGone.has(getPid(p.originalPost)) );         // any repost wrapper

setPosts   (keep);
setMyPosts (keep);
setAllPosts(keep);

unsyncedMineRef.current =
  unsyncedMineRef.current.filter(p => !idsGone.has(getPid(p)));


        
          /* 4️⃣ walk summary docs top-down and drop every matching id */
          const summariesRef = collection(db, 'socialSummaries');
          const newestSnap   = await getDocs(
            query(summariesRef, orderBy('__name__', 'desc'), limit(1))
          );
        
          if (!newestSnap.empty) {
            let idx        = parseInt(newestSnap.docs[0].id.split('_')[1], 10);
            const overhead = 200;                         // padding for sizeEstimate
        
            while (idx >= 1) {
              const docId   = `summary_${idx}`;
              const docRef  = doc(db, 'socialSummaries', docId);
              const snap    = await getDoc(docRef);
              if (!snap.exists()) { idx--; continue; }
        
              const data       = snap.data();
              const postsArray = data.posts || [];
              let   changed    = false;
        
              for (let i = postsArray.length - 1; i >= 0; i--) {
                if (idsGone.has(postsArray[i].postId)) {
                  const removed = postsArray.splice(i, 1)[0];
                  data.sizeEstimate = Math.max(
                    (data.sizeEstimate || 0) -
                    (JSON.stringify(removed).length + overhead),
                    0
                  );
                  changed = true;
                }
              }
        
              if (changed) {
                await updateDoc(docRef, {
                  posts:        postsArray,
                  sizeEstimate: data.sizeEstimate
                });
                // keep scanning; ids can live in older summary docs too
              }
              idx--;
            }
          
        
        } else {
          /* no reposts found – just strip the original locally */
          setPosts   (prev => prev.filter(p => p.id !== post.postId));
          setMyPosts (prev => prev.filter(p => p.id !== post.postId));
          setAllPosts(prev => prev.filter(p => p.id !== post.postId));
        }
      }
  
      /* ----------------------------------------------------------------
         COMMENT / REPLY EXTRA UPDATES
         ---------------------------------------------------------------- */
      if (type === 'comment') {
        const postRef = doc(db, 'posts', postId);
        await updateDoc(postRef, { commentCount: increment(-1) });
  
        setComments(prev => prev.filter(c => c.commentId !== post.postId));
        setPosts(prev => prev.map(p => {
          if (p.id === postId) {
            const newCnt = Math.max((p.commentCount || 1) - 1, 0);
            setLocalCommentCount(newCnt);
            return { ...p, commentCount: newCnt };
          }
          return p;
        }));
      }
  
      if (type === 'reply') {
        setComments(prev => prev.map(c => {
          if (c.commentId === commentId) {
            return { ...c,
              replies: (c.replies || []).filter(r => r.replyId !== post.postId)
            };
          }
          return c;
        }));
      }
  
      setActiveItemId(null);          // clear selection
    } catch (err) {
      console.error('Error deleting the document:', err);
    }
  };
  

const getCachedUserDoc = async (userId) => {
  let userDataCached = [];
  let userDataCachedNew = [];
  const now = new Date().getTime();

  if (!userDataCached || now - userDataCached.timestamp >= CACHE_DURATION) {
      
      const userDocRef = doc(firestore, 'users', userId);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
          
          const freshUserData = userDocSnap.data();

          
          // Update userDataCached structure with fresh data and timestamp
          userDataCachedNew = {
              ...freshUserData, // overwrite with fresh data from Firestore
              profileImageUrl: freshUserData?.profileImageUrl,
              timestamp: now
          };


      } else {
          console.error(`[getCachedUserDoc] No document found in Firestore for userId: ${userId}`);
      }
  } else {
      
      userDataCachedNew = userDataCached;
  }

  return userDataCachedNew;
};





const scrollContainerRef = useRef(null);
const sentinelRef = useRef(null);

useEffect(() => {
  const handleIntersection = (entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      
      if (!loadingMore && !allPostsLoaded) {
        
        fetchPosts(true);
      } else {
        
      }
    }
  };

  const observer = new IntersectionObserver(handleIntersection, {
    root: scrollContainerRef.current,
    threshold: 1.0,
  });

  const observeSentinel = () => {
    if (sentinelRef.current) {
      
      observer.observe(sentinelRef.current);
    }
  }; 

  // Add a small delay before setting up the observer
  const timerId = setTimeout(observeSentinel, 100); // 100 milliseconds

  return () => {
    clearTimeout(timerId);
    if (sentinelRef.current) {
      
      observer.unobserve(sentinelRef.current);
    }
  };
}, [posts, allPostsLoaded, loadingMore]);



const handlePressProfile = (profile) => {
  const clonedProfile = JSON.parse(JSON.stringify(profile));
  const targetRoute = profile.userId === userId2 ? '/mydat/profile' : `/userprofile/${profile.username}`;
  navigate(targetRoute, { state: { profile: clonedProfile, fromURL: false } });
};



const fetchUserProfile = async (userId) => {
  try {
    const userDocRef = doc(firestore, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      handlePressProfile(userDoc.data());
    } else {
      
    }
  } catch (error) {
    console.error('Error fetching user profile:', error);
  }
};

const fetchUserProfileByUserId = async (userId) => {
  if (!userId) {
    
    return;
  }

  try {
    fetchUserProfile(userId);

  } catch (error) {
    console.error('fetchUserProfileByUserId: Error fetching user by userId:', error);
  } finally {

    setIsLoading(false);
  }
};


const handlePressLiveProfile = async (live) => {
  if (!live?.userId) return;

  if (tokensUtility < 1) {
            alert("Add Utility Tokens to join this livestream");
    return;
  }
      setJoiningLive(true);

  try {
    const userDocRef = doc(firestore, 'users', live.userId);
    const snap = await getDoc(userDocRef);

    if (snap.exists()) {
      const data = snap.data();
      const profile = { userId: snap.id, ...data };
      await startViewingLivestream(profile);  // pass fetched profile directly
    } else {
        setJoiningLive(false);
      console.warn('Live user not found:', live.userId);
    }
  } catch (e) {
      setJoiningLive(false);
    console.error('handlePressLiveProfile: failed to fetch or start live:', e);
  }
};



  const renderOptions = () => {
    if (!activeItemId) return null;
    const { post, type } = activeItemId;
    const isOwner = (type === 'post' ? post.userId : type === 'comment' ? comments.find(c => c.commentId === post.id).userId : comments.find(c => c.replies.some(r => r.replyId === post.id)).replies.find(r => r.replyId === post.id).userId) === userId2;

    return (
      <div style={styles.optionsContainer} onClick={(e) => e.stopPropagation()}>
        {isOwner && (
          <button onClick={(e) => { e.stopPropagation(); handleDelete(); }}>
            Delete
          </button>
        )}
        {!isOwner && (
          <button onClick={(e) => { e.stopPropagation(); handleReport(post); }}>
            Report
          </button>
        )}
      </div>
    );
  };

  const handleToggleOptions = (post, type, commentId, postId = null) => {
    const newItemActive = { post, type, commentId, postId };
    if (activeItemId && activeItemId.post.postId === post.postId && activeItemId.type === type) {
      setActiveItemId(null);
    } else {
      setActiveItemId(newItemActive);
    }
  };



  const handleMediaUriTap = async (mediaUri, mediaType) => {
    if (mediaType === 'video') {
      setCurrentVideoUri(mediaUri);
      setModalVisible(true);
    } else {
      setModalVisible(true);
      setCurrentImage(mediaUri);
    }
  };

  const handleShare = (post) => {
    setPostToShare(post);
    setSharePostActive(true);
  };

  const handleReport = async (post) => {
    const db = getFirestore();
    const reportRef = doc(collection(db, 'reports'));

    const reportData = {
      reportId: reportRef.id,
      postId: post.id,
      text: post.text || '',
      imageUri: post.imageUri || '',
      userId: post.userId,
      username: post.username,
      name: post.name,
      profileImageUrl: post.profileImageUrl,
      createdAt: serverTimestamp(),
      reportedAt: serverTimestamp(),
    };

    try {
      await setDoc(reportRef, reportData);
      setReportComplete(true);
    } catch (error) {
      console.error("Error reporting the post: ", error);
    }
  };

  const formatTimeAgo = (firestoreTimestamp) => {

    const postDate = firestoreTimestamp.toDate ? firestoreTimestamp.toDate() : new Date(firestoreTimestamp.seconds * 1000);
  
    const now = new Date();
    const differenceInSeconds = Math.floor((now - postDate) / 1000);
    const differenceInMinutes = Math.floor(differenceInSeconds / 60);
    const differenceInHours = Math.floor(differenceInMinutes / 60);
    const differenceInDays = Math.floor(differenceInHours / 24);
  
    let formattedTimeAgo;
    if (differenceInDays > 0) {
      formattedTimeAgo = `${differenceInDays}d`;
    } else if (differenceInHours > 0) {
      formattedTimeAgo = `${differenceInHours}h`;
    } else if (differenceInMinutes > 0) {
      formattedTimeAgo = `${differenceInMinutes}m`;
    } else {
      formattedTimeAgo = `${differenceInSeconds}s`;
    }
  
    
    return formattedTimeAgo;
  }


  const handleVideoError = async (item) => {
    const functions = getFunctions();
    console.error(`Video failed to load for postId: ${item.postId}`);
  
    // Call the Cloud Function to process the video
    try {
      const convertAndFixVideo = httpsCallable(functions, 'convertFixVideo');
  
      const result = await convertAndFixVideo({
        postId: item.postId,  // Post ID to update after conversion
        videoUri: item.imageUri,  // Original video URL (that is failing)
        userId: item.userId  // User ID for organizing uploads
      });
  

  
    } catch (error) {
      console.error('Error triggering video conversion Cloud Function:', error);
    }
  };
  



  // --- audio & playback state ---
const [previewMuted, setPreviewMuted] = useState(true);
const [snippetAudible, setSnippetAudible] = useState(false);   // true when the snippet audio element is playing
const [activeVideoUri, setActiveVideoUri] = useState(null);    // which <video> should be considered "active"
const [isPlaying, setIsPlaying] = useState(false);             // global snippet playing state (parity with RN)
const [isVideoPlaying, setIsVideoPlaying] = useState(false);   // any video currently playing
const [mutedVideos, setMutedVideos] = useState({});            // map<videoUri, boolean>

const globalAudioRef = useRef(new Audio());                    // single audio element for song snippets
const playProgressRef = useRef({});                            // map<postId, {accMs, lastPos, countedInCycle}>
const intersectionRef = useRef(null);                          // IntersectionObserver instance

const VIEW_REQUIREMENT_MS = 5000;                              // 5s view requirement



// Derive a snippet URL similar to RN getItemPreviewURL()
const getItemPreviewURL = (item) => {
  const s = item?.songSnippet || {};
  return (
    s.previewURL || s.PreviewURL || s.SongURL || s.songURL ||
    item?.__parentAlbum?.previewURL || item?.__parentAlbum?.SongURL || ''
  );
};

// Toggle global snippet audio for a specific item
const togglePreviewMuted = (item) => {
  const audio = globalAudioRef.current;
  if (!audio) return;
  const url = getItemPreviewURL(item);
  if (!url) return;

  // If a different snippet is requested while playing, swap source
  const switchingTrack = audio.src !== url;

  if (previewMuted || switchingTrack) {
    audio.src = url;
    audio.currentTime = 0;
    audio.play().then(() => {
      setPreviewMuted(false);
      setSnippetAudible(true);
      setIsPlaying(true);
      // when snippet is audible, keep videos muted
      Object.values(videoRefs.current).forEach(v => v && v.pause());
      setIsVideoPlaying(false);
      setActiveVideoUri(null);
    }).catch(() => {});
  } else {
    audio.pause();
    setPreviewMuted(true);
    setSnippetAudible(false);
    setIsPlaying(false);
  }
};

// Simple per-video mute toggle (for non-snippet videos)
const toggleMute = (uri) => {
  setMutedVideos(prev => {
    const next = { ...prev, [uri]: !(prev[uri] ?? true) };
    const v = videoRefs.current[uri];
    if (v) v.muted = !!next[uri];
    return next;
  });
};

// Register refs for each <video>
const registerVideoRef = (uri, el) => {
  if (!uri) return;
  if (el) {
    videoRefs.current[uri] = el;
  } else {
    delete videoRefs.current[uri];
  }
};




const onPlaybackFor5s = (postId, ownerUserId) => (e) => {
  const el = e.currentTarget; // HTMLVideoElement
  if (!el || !el.duration || isNaN(el.duration)) return;

  // Skip counting if this is the current user's own video
  if (ownerUserId && typeof userId2 === 'string' && ownerUserId === userId2) return;

  // Ignore if paused or not ready
  if (el.paused || el.readyState < 2) return;

  const durMs = Math.max(0, el.duration * 1000);
  const threshold = Math.min(VIEW_REQUIREMENT_MS, durMs);

  const prog = (playProgressRef.current[postId] ||= {
    accMs: 0,
    lastPos: null,
    countedInCycle: false,
  });

  const posMs = Math.max(0, el.currentTime * 1000);

  // Detect loop vs scrub (web approximation of RN logic)
  const movedBackward   = prog.lastPos != null && posMs < prog.lastPos - 1000;     // >1s back
  const nearStart       = posMs <= 750;                                            // ~0.75s
  const wasNearEnd      = prog.lastPos != null && prog.lastPos >= durMs - 1000;    // last tick ~end
  const didLoopLikely   = movedBackward && nearStart && (el.loop === true || wasNearEnd);

  if (didLoopLikely) {
    prog.accMs = 0;
    prog.countedInCycle = false;
  } else if (movedBackward && !nearStart) {
    // user scrubbed backwards mid-video; keep accMs within current position
    prog.accMs = Math.min(prog.accMs, posMs);
  }

  // Accumulate only while actually playing
  if (!el.paused && el.readyState >= 2) {
    if (prog.lastPos != null) {
      const delta = Math.max(0, posMs - prog.lastPos);
      prog.accMs += delta;
    }
  }

  // Short videos: if it finished and duration < threshold, count once
  const ended = el.ended === true || (wasNearEnd && nearStart && movedBackward);
  if (!prog.countedInCycle && ended && durMs < VIEW_REQUIREMENT_MS) {
    prog.countedInCycle = true;
    addViewedVideo(postId);
    bumpLocalView(postId, 1);
  }

  // Normal case: hit the 5s threshold (or duration threshold)
  if (!prog.countedInCycle && prog.accMs >= threshold) {
    prog.countedInCycle = true;
    addViewedVideo(postId);
    bumpLocalView(postId, 1);
  }

  prog.lastPos = posMs;
};


// Local UI bump (replace your existing local bump logic with this shape)
const bumpLocalView = (postId, delta = 1) => {
  setPosts(prev =>
    prev.map(p => (p.postId === postId ? { ...p, viewCount: (p.viewCount || 0) + delta } : p))
  );
};



useEffect(() => {
  const audio = globalAudioRef.current;
  if (!audio) return;

  const onPlay = () => { setSnippetAudible(true); setIsPlaying(true); };
  const onPause = () => { setSnippetAudible(false); setIsPlaying(false); };
  const onEnded = () => { setSnippetAudible(false); setIsPlaying(false); setPreviewMuted(true); };

  audio.addEventListener('play', onPlay);
  audio.addEventListener('pause', onPause);
  audio.addEventListener('ended', onEnded);

  audio.crossOrigin = 'anonymous';
  audio.preload = 'none';

  return () => {
    audio.removeEventListener('play', onPlay);
    audio.removeEventListener('pause', onPause);
    audio.removeEventListener('ended', onEnded);
  };
}, []);


  useEffect(() => {
  return () => {
    try {
      const a = globalAudioRef.current;
      if (a) { a.pause(); a.src = ''; }
      Object.values(videoRefs.current).forEach(v => v && v.pause());
    } catch {}
  };
}, []);

useEffect(() => {
  if (intersectionRef.current) {
    intersectionRef.current.disconnect();
    intersectionRef.current = null;
  }

  // Don't auto-play videos while a snippet is audible
  if (snippetAudible) {
    Object.values(videoRefs.current).forEach(v => v && v.pause());
    setIsVideoPlaying(false);
    setActiveVideoUri(null);
    return;
  }

  const obs = new IntersectionObserver((entries) => {
    let best = null;
    let bestRatio = 0;

    entries.forEach(entry => {
      const el = entry.target;
      const ratio = entry.intersectionRatio || 0;
      if (ratio > bestRatio) {
        best = el;
        bestRatio = ratio;
      }
    });

    // auto-play the most visible (>= 0.6), pause others
    Object.values(videoRefs.current).forEach(v => {
      if (!v) return;
      if (best && v === best && bestRatio >= 0.6) {
        v.play().then(() => {
          setActiveVideoUri(v.currentSrc || v.src || null);
          setIsVideoPlaying(true);
        }).catch(() => {});
      } else {
        v.pause();
      }
    });
  }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });

  Object.values(videoRefs.current).forEach(v => v && obs.observe(v));
  intersectionRef.current = obs;

  return () => {
    if (intersectionRef.current) intersectionRef.current.disconnect();
    intersectionRef.current = null;
  };
}, [posts, snippetAudible]);


  
 
  return (
    <div style={styles.fullScreen}>
      <div style={styles.scrollContainer} data-scroll-container ref={scrollContainerRef}>
                {liveUsers.length > 0 && (
          <div style={styles.liveUsersContainer}>
            <span style={styles.liveText}>Live</span>
            <div style={styles.liveUsersRow}>
              {liveUsers.map((u) => (
                <button
                  key={u.userId}
                  onClick={(e) => { e.stopPropagation(); handlePressLiveProfile(u); }}
                  style={styles.liveUserProfile}
                  title={u.username || 'Live user'}
                >
                  <img
                    src={u.profileImageUrl}
                    alt={u.username || 'live-user'}
                    style={styles.liveUserImage}
                  />
                  <div style={styles.liveUsername}>{u.username}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        <ul style={{ ...styles.scrollContainer2 }}>
          {posts.map((item) => (
            <li key={item.postId} onClick={() => handlePressPost(item)} style={styles.postContainer}>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={styles.contentRow}>
                  
                  <ProfilesDisplaySharePost userProfile={item} onPress={() => fetchUserProfileByUserId(item.userId)} />
                  

                  <button style={styles.moreInfoButton} onClick={(e) => {
    e.stopPropagation();
    
    handleToggleOptions(item, 'post');
  }}>
                    <img src={ellipsis} style={{ position: 'relative', bottom: '5px', width: '20px', height: '20px', backgroundColor: 'transparent', zIndex: '50000', pointerEvents: 'auto' }}></img>
                  </button>
                  {activeItemId && activeItemId.post.postId === item.postId && activeItemId.type === 'post' && renderOptions()}
                </div>
              </div>
              {item?.songSnippet && (
  <div style={styles.songSnippetRow}>
    <div style={styles.songIconBtn}>
      <IoMusicalNotesOutline size={10} color="#FFFFFF" />
    </div>
    <span style={styles.songSnippetText} title={`${(item.songSnippet.artist || 'Unknown Artist')} - ${(item.songSnippet.name || 'Untitled')}`}>
      {(item.songSnippet.artist || 'Unknown Artist') + ' - ' + (item.songSnippet.name || 'Untitled')}
    </span>
  </div>
)}

              {item?.media ? (
                <div onClick={(e) => { e.stopPropagation(); handleMove(item.media); }} style={styles.imageContainer}>
    <img src={item.media.ArtworkURL} alt="Media" style={styles.postImage} />
  </div>
) : item.imageUri ? (
  <div style={item.text ? styles.mediaContainer : { ...styles.mediaContainer, ...styles.additionalMargin }}>
    {item.mediaType === 'video' ? (
      <div style={styles.mediaContainer2}>
<video
  ref={(el) => registerVideoRef(item.imageUri, el)}
  src={item.imageUri}
  style={styles.mediaThumbnail2}
  playsInline
  loop
  controls={false}
  muted={item?.songSnippet ? true : (mutedVideos[item.imageUri] ?? true)}
  onTimeUpdate={onPlaybackFor5s(item.postId, item.userId)}
  onClick={(e) => e.stopPropagation()}
  onError={(e) => handleVideoError(item)}
/>
{item?.songSnippet ? (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(item); }}
    style={{ position: 'absolute', right: 8, bottom: 8, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
) : (
  <button
    onClick={(e) => { e.stopPropagation(); toggleMute(item.imageUri); }}
    style={{ position: 'absolute', right: 6, bottom: 6, zIndex: 5, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle video mute"
  >
    {(mutedVideos[item.imageUri] ?? true)
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

      </div>
    ) : (
      <img src={item.imageUri} alt="Media" style={styles.postImage} />
      
    )}
    {item?.songSnippet && (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(item); }}
    style={{ position: 'absolute', right: 16, bottom: 36, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

  </div>
) : null}


{item.text && (
  <p
    style={{
      whiteSpace: 'pre-wrap',  // This preserves both spaces and line breaks.
      ...(item.mediaType === 'video'
        ? styles.postText2
        : item.imageUri
        ? styles.postText
        : styles.postTextNoImage)
    }}
  >
    {item.username === "spndatnews" ? (
      <>
        {item.text.substring(0, 500)}
        {item.text.length > 500 && "..."}
      </>
    ) : (
      item.text.split(/(\@\w+)/g).map((part, index) => {
        const tagsToUse =
          item.taggedUsers && item.taggedUsers.length > 0
            ? item.taggedUsers
            : item.tags;

        if (part.startsWith('@') && tagsToUse) {
          const userTag = tagsToUse.find(
            (tag) => `@${tag.username}` === part
          );
          if (userTag) {
            return (
              <span
                style={styles.tagContainer}
                key={index}
                onClick={() => fetchUserProfileByUserId(userTag.userId)}
              >
                <span style={{ color: '#62fbfa' }}>{part} </span>
              </span>
            );
          }
        }

        return <span key={index}>{part} </span>; // Ensure proper spacing
      })
    )}
  </p>
)}




              {item.profile && (
                <ProfilesDisplaySharePost userProfile={item.profile} onPress={() => fetchUserProfileByUserId(item.profile.userId)} />
              )}
              {item.originalPost && (
                <div onClick={() => handlePressOriginalPost(item.originalPost)} style={styles.postContainer2}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={styles.contentRow}>
                      <ProfilesDisplaySharePost userProfile={item.originalPost} onPress={() => fetchUserProfileByUserId(item.originalPost.userId)} />

                    </div>
                  </div>
                  {item?.originalPost?.media ? (
  <div onClick={(e) => { e.stopPropagation(); handleMove(item.originalPost.media); }} style={styles.imageContainer}>
    <img src={item.originalPost.media.ArtworkURL} alt="Media" style={styles.postImage} />
  </div>
) : item.originalPost.imageUri ? (
  <div style={item.originalPost.text ? styles.mediaContainer : { ...styles.mediaContainer, ...styles.additionalMargin }}>
    {item.originalPost.mediaType === 'video' ? (
      <div style={styles.mediaContainer2}>
        <video
          src={item.originalPost.imageUri}
          style={styles.mediaThumbnail2}
          controls
          onClick={(e) => e.stopPropagation()}
          onError={(e) => handleVideoError(item)}
        />
      </div>
    ) : (
      <img src={item.originalPost.imageUri} alt="Media" style={styles.postImage} />
    )}
  </div>
) : null}

                  {item?.originalPost?.profile && (
                    <ProfilesDisplaySharePost userProfile={item?.originalPost?.profile} onPress={() => fetchUserProfileByUserId(item?.originalPost?.profile?.userId)} />
                  )}
{item.originalPost.text && typeof item.originalPost.text === 'string' && (
  <p
    style={{
      whiteSpace: 'pre-wrap',  // This preserves both spaces and line breaks.
      ...(item.originalPost.imageUri
        ? styles.postText
        : styles.postTextNoImage)
    }}
  >
    {item.originalPost.username === "spndatnews" ? (
      <>
        {item.originalPost.text.substring(0, 500)}
        {item.originalPost.text.length > 500 && "..."}
      </>
    ) : (
      item.originalPost.text
    )}
  </p>
)}


                </div>
              )}
              <div style={styles.iconsContainer}>
              <button style={styles.iconButtonLike} onClick={(e) => { e.stopPropagation(); handleLikePress(item.postId); }}>
                  <div style={styles.likeButtonContainer}>
                  <img src={likes[item.postId] ? LikeIconActive : LikeIcon} alt="Like" style={styles.iconImage} />
                    <span style={styles.likeCount}>{item.likeCount || 0}</span>
                  </div>
                </button>
                <button onClick={() => handlePressPostComment(item)} style={styles.iconButton}>
                  <div style={styles.likeButtonContainer}>
                  <img src={CommentIcon} alt="Comment" style={styles.iconImage} />
                    <span style={styles.likeCount}>{item.commentCount || 0}</span>
                  </div>
                </button>
                {!item.originalPost && (
                  <button style={styles.iconButton} onClick={(e) => { e.stopPropagation(); handleRepost(item); }}>
                    <div style={styles.likeButtonContainer}>
                      <img src={
                        reposts[item.id] || (item.originalPost && reposts[item.originalPost.id])
                          ? RepostIconActive
                          : RepostIcon
                      } alt="Repost" style={styles.iconImage} />
                      <span style={styles.likeCount}>{item.repostCount || 0}</span>
                    </div>
                  </button>
                )}
                  <button
    style={styles.iconButton}
    onClick={e => { e.stopPropagation(); handleShare(item); }}
  >
    <div style={styles.likeButtonContainer}>
      <FaPaperPlane
        size={'14px'}     // match your other icon sizing
        color="white"
        style={{ transform: 'scaleX(-1)' }} // flip horizontally
      />
    </div>
  </button>

{item?.songSnippet && !item.imageUri && !item.media && (
  <button
    className="icon-button"
    style={{
      opacity: (isPlaying || isVideoPlaying) && !!activeMedia?.contentId ? 0.5 : 1,
      cursor: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 'default' : 'pointer',
      background: 'transparent',
      border: 'none',
      padding: 0,
    }}
    onClick={(e) => {
      e.stopPropagation();
      if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return;
      togglePreviewMuted(item);
    }}
  >
    <div className="like-button-container">
      {previewMuted ? (
        <IoVolumeMuteOutline
          size={'18px'}
          color="white"
        />
      ) : (
        <IoVolumeHigh
          size={'18px'}
          color="white"
        />
      )}
    </div>
  </button>
)}


  
    {item.mediaType === 'video' && (
    <div style={{ ...styles.iconButton, display: 'flex', alignItems: 'center' }}>
      <FaEye size={14} color="white" style={{ marginRight: 6 }} />
      <span style={styles.viewCountRight}>
        {(item.viewCount || 0).toLocaleString()}
      </span>
    </div>
  )}

              </div>
            </li>
            
          ))}
                        <div ref={sentinelRef} style={{ backgroundColor: 'transparent', height: '50px' }}></div>
                        <div style={styles.extraSpace}></div>
        </ul>
        {reportComplete && (
          <div style={styles.fullScreenOverlay} onClick={() => setReportComplete(false)}>
            <img src="/assets/DATBG.png" alt="Background" style={styles.fullScreenImage} />
            <span style={styles.overlayText}>Report Successful</span>
          </div>
        )}
        {showActivityIndicator && (
          <div style={styles.activityIndicator}></div>
        )}
      </div>

    <Modal
  isOpen={joiningLive}
  style={{
    overlay: {
      backgroundColor: 'rgba(17, 14, 14, 0.75)',
      zIndex: 1000000
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      background: 'transparent',
      color: 'white',
      borderRadius: '10px',
      padding: '20px',
      textAlign: 'center',
      zIndex: 1000000,
    }
  }}
>
  <h2>Joining Livestream...</h2>
</Modal>

      <Modal
      isOpen={sharePostActive}
      onRequestClose={() => setSharePostActive(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '30%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '260px',
          width: '80%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <ProfilesDisplayShareDATpost/>
      </div>
      <div style={styles.cancelContainer}>
      <button style={styles.cancelButton} onClick={() => setSharePostActive(false)}>Cancel</button>
      </div>
    </Modal>
    <Modal
      isOpen={showSharePostPopup}
      onRequestClose={() => setShowSharePostPopup(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '400px',
          width: '95%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <SharePostPopup/>
      </div>
      <div style={styles.cancelContainer}>
      <button style={styles.cancelButton} onClick={() => setShowSharePostPopup(false)}>Cancel</button>
      </div>
    </Modal>
    </div>
  );
  
};

const styles = {
    postContainer: {
      padding: '7px',
      backgroundColor: "rgba(0,0,0,0.5)",
      borderRadius: '8px',
      border: '1px solid rgba(23, 195, 250, 0.5)', // Use shorthand property for border
      marginLeft: '10px',
      marginRight: '10px',
      zIndex: '500',
      position: 'relative',
      cursor: 'pointer',
    },
    sharingPost: {
width: '100%',
height: '100%',
display: 'flex',
alignSelf: 'center',
justifyContent: 'center',
    },
    cancelContainer: {
display: 'flex',
width: '100%',
height: '100%',
justifyContent: 'center',
alignSelf: 'center',
    },
    cancelButton: {
      padding: '10px 20px',
      marginBottom: '80px',
      display: 'flex',
      justifyContent: 'center',
      alignSelf: 'center',
      margin: '0 auto',
      position: 'absolute',
      bottom: '10px',
      backgroundColor: 'transparent',
      color: '#62fbfa',
      border: 'none',
      fontSize: '20px',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    extraSpace: {
      height: '300px',
        },
  
  activityIndicator: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  controlButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    padding: '10px'
  },
  iconButton: {
    paddingLeft: '20px',
    marginLeft: '-20px',
    paddingRight: '20px',
    marginRight: '-20px',
    marginBottom: '-10px',
    paddingBottom: '10px',
    paddingTop: '8px',
    marginTop: '-8px',
    backgroundColor: 'transparent',
    border: 'none',

  },
  iconButtonLike: {
    paddingLeft: '20px',
    marginLeft: '-20px',
    paddingRight: '20px',
    marginRight: '-20px',
    marginBottom: '-10px',
    paddingBottom: '10px',
    paddingTop: '8px',
    marginTop: '-8px',
    backgroundColor: 'transparent',
    border: 'none',
    // Any other styles you want to apply to the touchable opacity
  },
  
  likeButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  iconImage: {
    width: '16px',
    height: '16px',
    marginRight: '5px',
    backgroundColor: 'transparent',
  },
  likeCount: {
    color: 'white',
    fontSize: '16px',
  },
  postContainer2: {
    padding: '7px',
    backgroundColor: "rgba(0,0,0,0.5)",
    borderWidth: '1px',
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)',
    marginLeft: '10px',
    marginRight: '10px',
    marginBottom: '20px',
    cursor: 'pointer',
  },
  postText: {
    marginTop: '20px',
    marginLeft: '15px',
    marginBottom: '18px',
    marginRight: '20px',
    color: 'white',
    fontSize: '16px',
    fontFamily: 'brhendrix',
  },
  postText2: {
    marginTop: '20px',
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '15px',
    color: 'white',
    fontSize: '16px',
    fontFamily: 'brhendrix',
  },
postTextNoImage: {
  marginTop: '-14px',
  marginLeft: '50px',
  marginBottom: '8px',
  marginRight: '20px',
  color: 'white',
  fontSize: '16px',
  fontFamily: 'brhendrix',
},
  postImage: {
    width: '100%',
    height: '300px',
    alignSelf: 'center',
    marginTop: '10px',
    marginBottom: '20px',
    objectFit: 'contain',
  },
  fullScreen: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    overflowY: 'scroll',
  },
  scrollContainer2: {
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: 2,
    listStyleType: 'none',
    padding: 0,
    overflowX: 'hidden',
    overflowY: 'scroll', // Ensure vertical scrolling
  },
  scrollContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: 3,

    overflowY: 'scroll', // Ensure vertical scrolling
  },
  iconsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginBottom: '5px',
  },
  moreInfoButton: {
    marginLeft: 'auto',
    marginBottom: '20px',
    width: '50px',
    pointerEvents: 'auto',
    height: '100%',
    padding: '10px',
    border: 'none',
    backgroundColor: 'transparent',
    zIndex: '50000',
    position: 'relative',
    cursor: 'pointer',
  },
  
  contentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  timeAgoStyle: {
    color: 'white',
    fontSize: '14px',
    flexShrink: 1,
    right: 50,
    position: 'relative',
    marginBottom: '15px',
    justifyContent: 'center',
    alignSelf: 'center',
    paddingHorizontal: '5px',
    paddingBottom: '21px',
  },
  buttonTouchableArea: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  optionsContainer: {
    position: 'absolute',
    right: 20,
    display: 'flex',
    flexDirection: 'column',
    top: '9px',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '5px',
    padding: '5px',
    marginRight: '5%',
    zIndex: 10000,
  },
  fullscreenVideo: {
    width: '100%',
    height: '100%',
    backgroundColor: '#000',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    padding: '10px',
    backgroundColor: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  tagContainer: {
    display: 'inline',
    cursor: 'pointer',
  },
  playIcon: {
    position: 'absolute',
    width: '68px',
    height: '80px',
    alignSelf: 'center',
  },
  fullScreenOverlay: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  fullScreenImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  overlayText: {
    color: 'white',
    fontSize: '20px',
    fontWeight: 'bold',
    position: 'absolute',
    textAlign: 'center',
    width: '100%',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
    overflow: 'hidden',
    borderRadius: '10px',
    marginBottom: '20px',
  },
  mediaContainer: {
    display: 'flex', 
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '10px',
    objectFit: 'contain',
    zIndex: 500,
  },
  mediaContainer2: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '20px',
    display: 'flex',
    marginBottom: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
    zIndex: 500,
    
  },
  mediaThumbnail2: {
    width: '100%',
    height: '120%',
    objectFit: 'cover',
  },
    liveUsersContainer: {
    padding: '10px',
    marginTop: '10px',
    position: 'relative',
  },
  liveText: {
    position: 'absolute',
    top: '-8px',
    left: '12px',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'red',
  },
  liveUsersRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '14px',
    overflowX: 'auto',
    paddingTop: '8px',
    paddingBottom: '4px',
  },
  liveUserProfile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
  liveUserImage: {
    width: '64px',
    height: '64px',
    borderRadius: '999px',
    border: '4px solid #62fbfa',
    objectFit: 'cover',
  },
  liveUsername: {
    marginTop: '6px',
    fontSize: '12px',
    color: 'white',
    textAlign: 'center',
    maxWidth: '80px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },




songSnippetRow: {
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 8px',
  margin: '6px 0 4px',
  marginTop: '-48px',
    marginBottom: '10px',
  marginLeft: '42px',
},
songMuteBtn: {
  width: 22,
  height: 22,
  borderRadius: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255,255,255,0.18)',
},
songIconBtn: {
  width: 10,
  height: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
},
songSnippetText: {
  color: '#FFFFFF',
  fontSize: 12,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '86%',
},
viewCountRight: {
  color: '#FFFFFF',
  fontSize: 12,
},
mediaContainer2: {
  position: 'relative',               // needed for overlay buttons
},


};



export default Social;
